module.exports = __webpack_public_path__ + "static/media/404.3c9803a6.svg";